import React, { useState, useRef } from "react";
import {
  Box,
  Card,
  Grid,
  Typography,
  Divider,
  Paper,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import CompanyProfile from "./BusinessComponents/CompanyProfile";
import SolutionsApply from "./BusinessComponents/SolutionsApply";
import Directors from "./BusinessComponents/Directors";
import Shareholders from "./BusinessComponents/Shareholders";
import BusinessInfo from "./BusinessComponents/BusinessInfo";
import SettlementInfo from "./BusinessComponents/SettlementInfo";
import SecurityQuestions from "./BusinessComponents/SecurtiyQuestions";
import SecretKey from "./BusinessComponents/SecretKey";

const sidebarItems = [
  "Company Profile",
  "Solutions Applying For",
  "Director's Info",
  "Shareholder's Info",
  "Business Info",
  "Settlement Info",
  "Security Question Info",
  // "Secret Key",
  // "Block Customer",
];

const BusinessSetting = () => {
  const [activeTab, setActiveTab] = useState("Company Profile");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const scrollRef = useRef();

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 150;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Grid container spacing={3}>
        {/* Sidebar */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={4}
            sx={{
              p: 2,
              borderRadius: 4,
              bgcolor: "#ffffff",
              display: "flex",
              flexDirection: { xs: "column", md: "column" },
              position: "relative",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
            }}
          >
            {/* Heading */}
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 700,
                color: "#1a237e",
                display: { xs: "none", md: "block" },
              }}
            >
              Business Settings
            </Typography>

            {/* Scrollable Sidebar */}
            <Box
              sx={{
                display: "flex",
                overflowX: { xs: "auto", md: "visible" },
                flexDirection: { xs: "row", md: "column" },
                gap: 1,
              }}
              ref={scrollRef}
            >
              {sidebarItems.map((item) => (
                <Box
                  key={item}
                  onClick={() => setActiveTab(item)}
                  sx={{
                    py: 1,
                    px: 2,
                    borderRadius: 2,
                    cursor: "pointer",
                    backgroundColor: activeTab === item ? "#e8f0fe" : "transparent",
                    color: activeTab === item ? "#0d47a1" : "#555",
                    fontWeight: activeTab === item ? 700 : 500,
                    whiteSpace: "nowrap",
                    minWidth: { xs: "fit-content", md: "auto" },
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                      color: "#0d47a1",
                    },
                  }}
                >
                  {item}
                </Box>
              ))}
            </Box>

            {/* Scroll Buttons (only on mobile) */}
            {isMobile && (
              <>
                <IconButton
                  onClick={() => scroll("left")}
                  size="small"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: -12,
                    transform: "translateY(-50%)",
                    background: "#0d47a1",
                    color: "#fff",
                    zIndex: 10,
                    "&:hover": {
                      background: "#0d47a1",
                      transform: "translateY(-50%) scale(1.1)",
                    },
                  }}
                >
                  <ChevronLeft fontSize="medium" />
                </IconButton>

                <IconButton
                  onClick={() => scroll("right")}
                  size="small"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    right: -12,
                    transform: "translateY(-50%)",
                    background: "#0d47a1",
                    color: "#fff",
                    zIndex: 10,
                    "&:hover": {
                      background: "#0d47a1",
                      transform: "translateY(-50%) scale(1.1)",
                    },
                  }}
                >
                  <ChevronRight fontSize="medium" />
                </IconButton>
              </>
            )}
          </Paper>
        </Grid>

        {/* Main Form Card */}
        <Grid item xs={12} md={9}>
          <Card
            elevation={4}
            sx={{
              borderRadius: 4,
              p: { xs: 2, md: 4 },
              bgcolor: "#ffffff",
              boxShadow: "0 6px 24px rgba(0,0,0,0.04)",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 700, color: "#1a237e" }}
            >
              {activeTab}
            </Typography>
            <Divider sx={{ mb: 3 }} />

            {/* Company Profile Form */}
            {activeTab === "Company Profile" && (
              <CompanyProfile />
            )}

            {activeTab === "Solutions Applying For" && (
              <SolutionsApply />
            )}

            {activeTab === "Director's Info" && (
              <Directors />
            )}

            {activeTab === "Shareholder's Info" && (
              <Shareholders />
            )}

            {activeTab === "Business Info" && (
              <BusinessInfo />
            )}

            {activeTab === "Settlement Info" && (
              <SettlementInfo />
            )}

            {activeTab === "Security Question Info" && (
              <SecurityQuestions />
            )}

            {/* {activeTab === "Secret Key" && (
              <SecretKey />
            )} */}
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BusinessSetting;
